export const NAME = "name";
export const PROJECT_ID = "projectId";
export const PROJECT_CODE = "code";
export const PROJECT_CATEGORY_ID = "projectCategoryId";
export const ESTIMATED_START_DATE = "estimatedStartDate";
export const ESTIMATED_END_DATE = "estimatedEndDate";
export const CLIENT_NAME = "clientName";
export const PROJECT_VALUE = "budget";
export const ADDRESS = "location";
export const DESCRIPTION = "description";
export const STATUS = "status";
